'use client';

import type { CmsShellViewerMode } from '@/cms/chrome/shell-viewer-mode';
import { CmsAccountSettingsDialogHost } from '@/cms/components/chrome/cms-account-settings-dialog-host';
import { CmsAccountSettingsDialogProvider } from '@/cms/components/chrome/cms-account-settings-state';
import type { CmsAccountSettingsPresentation } from '@/components/account-settings/cms-account-settings-dialog';
import type { ReactNode } from 'react';

export function CmsAccountSettingsDialogOwner({
  children,
  locale,
  presentation,
  viewerMode,
}: {
  children: ReactNode;
  locale: string;
  presentation: CmsAccountSettingsPresentation;
  viewerMode: CmsShellViewerMode;
}) {
  return (
    <CmsAccountSettingsDialogProvider>
      {children}
      <CmsAccountSettingsDialogHost
        locale={locale}
        presentation={presentation}
        viewerMode={viewerMode}
      />
    </CmsAccountSettingsDialogProvider>
  );
}
